import React from 'react'
import Header  from './components/header/Header';
import Nav from './components/nav/Nav';
import InteractiveTerminal from './components/terminal/InteractiveTerminal';
import About from './components/about/About';
import Experience from './components/experience/Experience';
import Portfolio from './components/portfolio/Portfolio';
import SideProjects from './components/sideprojects/SideProjects';
import Testimonials from './components/testimonials/Testimonials';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

const App = () => {
    return (
        <>
            <Header/>
            <Nav/>
            <InteractiveTerminal/>
            <About/>
            <Experience/>
            <Portfolio/>
            <SideProjects/>
            <Testimonials/>
            <Contact/>
            <Footer/>
        </>
    )
}
export default App;
